<template>
    <div class="card text-left" v-on:click="clickCard(''+ slug + '')">
        <h5>{{title}}</h5>
        <div v-if="apply" class="submission-deadline">
            <span class="deadline-text" v-if="calledFrom === 'Apply'">
                ⏰ Submission ends
            </span>
            <span class="deadline-text" v-else-if="calledFrom === 'ApplyChallenge'">
                ⏰ Challenge deadline
            </span> 
            
            {{convertedDate}}
            <br><br>
            <a class="btn btn-success" id="submit-work">
                {{ctaText}}
            </a>
            
        </div>
        <div v-else class="reward">{{rewardText}}
            <br><br>
            <a class="btn btn-success" id="submit-work">
                {{ctaText}}
            </a>
            
        </div>
        
    </div>
    
</template>


<script>
import firebase from '../services/firebase'

export default {
    name: 'RegisterCard',
    props: {
        title: String,
        rewardText: String,
        ctaText: String,
        ctaUrl: String,
        slug: String,
        clickCard: Function,
        apply: Boolean,
        deadline: Number,
        calledFrom: String
    },
    computed: {
        convertedDate: function() {
            console.log("deadline is " + this.deadline);
            if (this.calledFrom === "ApplyChallenge") {
                if (this.deadline !== null) {
                    var date = new Date(this.deadline + 345600000);
                }
                else {
                    var date = new Date();
                    var ts = date.getTime();
                    var date = new Date(ts + 345600000);
                    console.log("deadline is null");
                } 
                
            } else if (this.deadline !== null) {
                var date = new Date(this.deadline*1000);
            } else {
                var date = new Date();
                var ts = date.getTime();
                var date = new Date(ts + 345600000);
                console.log("deadline is null and applyChallenge is null");
            }
  
            return this.$moment(date).format('MMM Do, YYYY');
        }
    }
}
</script>


<style scoped>
    .card {
		margin-top:20px; 
		margin-bottom:20px; 
		margin-right: 0%;
		margin-left: 8%;
        padding-left:8%;
        padding-right:8%;
        padding-top:7%;
        padding-bottom:2%;
        width:92%;
		border:none;
		box-shadow: 4px 2px 4px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
        background-color:#fff;
        color:#333;
	}

    @media (max-width:600px) {
        .card {
            margin-left: 0;
        }
    }

    .card-company-icon {
        width:40px;
        height: 40px;
    }

    .reward {
        margin-top:20px;
        font-size:14px;
    }

    .submission-deadline {
        margin-top:20px;
        margin-bottom:0px;
        font-size:0.9rem;
    }

    .deadline-text {
        color:#666;
        margin-right: 2px;
    }

	#submit-work {
		margin-top:8px;
		padding-top:5%;
		padding-bottom:5%;
		padding-left:6%;
		padding-right:6%;
		width:100%;
		margin-bottom:8px;
		background-color:#f25792;
		border-color:#f25792;
		color:#fff;
        font-size:0.7rem;
        border-radius: 7px;
	}

</style>
